var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExpediente(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56.85 70",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Sustracci\\xF3n_19",
    "data-name": "Sustracci\\xF3n 19",
    className: "cls-1",
    d: "M52.18,61.3h0V15A10.33,10.33,0,0,0,41.86,4.67H8.7A6.54,6.54,0,0,1,15,0h35.3a6.57,6.57,0,0,1,6.56,6.57V55a6.53,6.53,0,0,1-4.67,6.3Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 10.78,
    y: 52.77,
    width: 15.57,
    height: 4.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 10.78,
    y: 43.43,
    width: 27.06,
    height: 4.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 10.78,
    y: 34.09,
    width: 27.06,
    height: 4.9
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "10.78 22.36 10.78 29.64 20.78 29.64 20.78 22.35 10.78 22.36"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M41.87,8.42H6.56A6.58,6.58,0,0,0,0,15V63.44A6.59,6.59,0,0,0,6.57,70H41.88a6.57,6.57,0,0,0,6.56-6.57V15A6.58,6.58,0,0,0,41.87,8.42Zm1.85,51.45a5.45,5.45,0,0,1-5.28,5.61H10a5.46,5.46,0,0,1-5.29-5.6V18.55A5.46,5.46,0,0,1,10,12.94H38.43a5.45,5.45,0,0,1,5.29,5.6Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpediente);
export default __webpack_public_path__ + "static/media/Expediente.ef361f1349624ef2cdf950618697d327.svg";
export { ForwardRef as ReactComponent };